import { gridSize } from '@confluence/typography-placeholder';

export const MIN_BANNER_HEIGHT = gridSize * 9;

export const BANNER_NAME = 'CookiesConsentBanner';
